import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Home from './components/Home';
import AboutSection from './components/AboutSection';
// import Services from './components/ServiceSection';
import Calendar from './components/CalendarComponent';
import Gallery from './components/Gallery';
import Goshala from './components/Goshala';
import GuestHouse from './components/GuestHouse';
import Footer from './components/Footer';
import './assets/styles/style.css';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";


function App() {
  return (
    <Router>
      <Header />
      <div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutSection />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/calendar" element={<Calendar />} />
          <Route path="/services/goshala" element={<Goshala />} />
          <Route path="/services/guesthouse" element={<GuestHouse />} />
          </Routes>
      </div>
      <Footer />
    </Router>
  );
}

export default App;
